/**
 * Forgot password service — DQ-4545.
 *
 * Single API boundary for the forgot password flow. Each call maps to one
 * backend endpoint:
 *   send-otp       -> returns the request token consumed by verify-otp
 *   verify-otp     -> returns the reset token consumed by reset-password
 *   reset-password -> completes the flow
 *
 * Tokens are returned to the caller and never persisted or logged here.
 */

import base from "../middlewares/interceptors";
import { resetPasswordUrl, sendOtpUrl, verifyOtpUrl } from "./constants";
import {
  ForgotPasswordResetRequest,
  ForgotPasswordResetResponse,
  ForgotPasswordSendOtpRequest,
  ForgotPasswordSendOtpResponse,
  ForgotPasswordVerifyOtpRequest,
  ForgotPasswordVerifyOtpResponse,
} from "../types/auth";

export const requestPasswordResetOtp = async (
  email: string,
): Promise<ForgotPasswordSendOtpResponse> => {
  const payload: ForgotPasswordSendOtpRequest = { email };
  const response = await base.post(sendOtpUrl, payload);
  return response?.data;
};

export const verifyPasswordResetOtp = async (
  resetToken: string,
  otp: string,
): Promise<ForgotPasswordVerifyOtpResponse> => {
  const payload: ForgotPasswordVerifyOtpRequest = { otp };
  const response = await base.post(verifyOtpUrl, payload, {
    params: { reset_token: resetToken },
  });
  return response?.data;
};

export const resetPassword = async (
  resetToken: string,
  password: string,
  confirmPassword: string,
): Promise<ForgotPasswordResetResponse> => {
  const payload: ForgotPasswordResetRequest = {
    new_password: password,
    confirm_password: confirmPassword,
  };
  const response = await base.post(resetPasswordUrl, payload, {
    params: { reset_token: resetToken },
  });
  return response?.data;
};
